<template>

  <loading-data-page-container
    :loading="!isInitialized && !loadingError"
    :loading-error="loadingError"
    :loading-error-message="loadingErrorMessage"
    :hint="loadingErrorHint"
    class="badge-page">

    <template v-if="isInitialized && !loadingError">

      <div class="semanticsection-title2 primary--text">Auszeichnungen
      </div>

      <div>Regelmäßige Auszeichnungen bestätigen der DMB Rechtsschutz ein hervorragendes Preis-Leistungs-Verhältnis.
        Bei Maklerumfragen hat der konzernunabhängige Rechtsschutz-Spezialist Top-Bewertungen!
      </div>

      <v-container v-for="(category, categoryIndex) in content.categories"
                   :key="'category-' + categoryIndex"
                   class="pa-0"
                   fluid>

        <v-row class="badge-block"
                  no-gutters>

          <v-col cols="12"
                 sm="8">

            <div class="subueber primary--text">{{ category.header }}
            </div>

            <div v-for="(section, sectionIndex) in category.sections"
                 :key="'section-' + sectionIndex"
                 class="block-section">

              <div v-if="section.sectionTitle"
                   class="subueber primary--text">{{ section.sectionTitle }}
              </div>

              <ul>
                <li v-for="(item, itemIndex) in section.items"
                    :key="'item-' + itemIndex">
                  {{ item.title }}
                </li>
              </ul>

            </div>
          </v-col>


          <v-col cols="12"
                 sm="4">
            <v-row class="badge-imgs"
                   no-gutters>

              <v-col v-for="(badge, badgeIndex) in category.badges"
                   :key="'img' + badgeIndex"
                   cols="12">

                <div :class="$vuetify.breakpoint.xsOnly ? 'centered' : ''"
                     class="img-container">
                  <a v-if="badge.link"
                     :href="badge.link"
                     target="_blank">
                    <img :src="badge.src">
                  </a>

                  <img v-else :src="badge.src">
                </div>

              </v-col>

            </v-row>
          </v-col>

        </v-row>

        <v-divider v-if="content.categories[++categoryIndex]" />

      </v-container>

    </template>

  </loading-data-page-container>

</template>

<script>
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

export default {
  name: "AuszeichnungenPage",
  components: { LoadingDataPageContainer },
  mixins: [contentLoadingMixin(["AboutAuszeichnungenUnternehmen", "AboutAuszeichnungenUnternehmenBadges", "AboutAuszeichnungenProdukte", "AboutAuszeichnungenProdukteBadges"])],
  computed: {
    content () {
      return { categories: [
          {
            header: 'Unternehmen',
            sections: this.AboutAuszeichnungenUnternehmen.sections,
            badges: this.AboutAuszeichnungenUnternehmenBadges
          },
          {
            header: 'Produkte',
            sections: this.AboutAuszeichnungenProdukte.sections,
            badges: this.AboutAuszeichnungenProdukteBadges
          }
        ]

      };
    }
  }
};
</script>

<style>

.badge-page .subueber {
  margin: 40px 0 24px 0;
}

.badge-page .semanticsection-title2 + .badge-block .subueber:first-child {
  margin-top: 0;
}

.badge-page .subueber + .block-section .subueber:first-child {
  margin-top: 16px;
}

.badge-page .v-divider {
  background-color: #979797;
  margin-top: 56px;
}

.badge-page .badge-imgs {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.badge-page .badge-imgs img, .badge-page .badge-imgs .img-container {
  width: 200px;
  margin-left: auto;
}

.badge-page .badge-imgs .img-container.centered {
  margin-right: auto;
}

.badge-page .badge-imgs .img-container:not(:last-child) {
  margin-bottom: 40px;
}

.badge-page .block-section ul {
  list-style: outside;
  margin-left: 16px;
  padding-left: 0;
}

.badge-page .block-section li:not(:last-child) {
  margin-bottom: 16px;
}

</style>
